export default "__VITE_ASSET__d01c66d7__"